import {
  ORDER_METHODS,
  SMART_PRICING_MODIFIER_TYPE,
  SMART_PRICING_RESOURCE_TYPE,
} from '../../../../../services/exports/Constants';

export default {
  title: {
    [SMART_PRICING_RESOURCE_TYPE.company]: 'Regola smart pricing globale di {{name}}',
    [SMART_PRICING_RESOURCE_TYPE.franchise]: 'Regola smart pricing master di {{name}}',
    [SMART_PRICING_RESOURCE_TYPE.menu]: 'Regola smart pricing del menu {{name}}',
    [SMART_PRICING_RESOURCE_TYPE.category]: 'Regola smart pricing della categoria {{name}}',
    [SMART_PRICING_RESOURCE_TYPE.product]: 'Regola smart pricing del prodotto {{name}}',
    [SMART_PRICING_RESOURCE_TYPE.modifier_group]: 'Regola smart pricing del gruppo modificatori {{name}}',
    [SMART_PRICING_RESOURCE_TYPE.modifier]: 'Regola smart pricing del modificatore {{name}}',
  },
  labels: {
    new: 'Nuovo',
    base_price: 'Prezzo base di {{name}}: {{value}}',
  },
  form: {
    resource: {
      [SMART_PRICING_RESOURCE_TYPE.menu]: 'Menu',
      [SMART_PRICING_RESOURCE_TYPE.category]: 'Categoria',
      [SMART_PRICING_RESOURCE_TYPE.product]: 'Prodotto',
      [SMART_PRICING_RESOURCE_TYPE.modifier_group]: 'Gruppo modificatori',
      [SMART_PRICING_RESOURCE_TYPE.modifier]: 'Modificatore',
      placeholder: 'Seleziona {{resource}}',
    },
    order_methods: {
      label: "Metodi d'ordine",
      placeholder: "Seleziona i metodi d'ordine a cui si applica la regola",
      options: {
        [ORDER_METHODS.pickup]: 'Ritiro',
        [ORDER_METHODS.delivery]: 'Consegna',
        [ORDER_METHODS.room_service]: 'Servizio in camera/al tavolo',
      },
    },
    modifier_type: {
      label: 'Tipo di modificatore di prezzo',
      placeholder: 'Seleziona il tipo di modificatore di prezzo',
      disabled_tooltip:
        'Il valore assoluto non è disponibile per le regole a livello di menu perché sovrascriverebbe il prezzo di ogni voce.',
      tooltip: {
        title: 'Il tipo di modificatore definisce il modo in cui i prezzi vengono modificati',
        description: {
          [SMART_PRICING_MODIFIER_TYPE.absolute]:
            'Assoluto: sovrascrive il prezzo della risorsa con il valore del modificatore specificato',
          [SMART_PRICING_MODIFIER_TYPE.percentage]:
            'Percentuale: aggiunge/sottrae la percentuale del modificatore specificato al/dal prezzo base della risorsa in base al segno del valore',
          [SMART_PRICING_MODIFIER_TYPE.fixed_value]:
            'Valore fisso: aggiunge/sottrae il valore fisso del modificatore specificato al/dal prezzo base in base al segno del valore',
        },
      },
      options: {
        [SMART_PRICING_MODIFIER_TYPE.absolute]: 'Assoluto',
        [SMART_PRICING_MODIFIER_TYPE.percentage]: 'Percentuale',
        [SMART_PRICING_MODIFIER_TYPE.fixed_value]: 'Valore fisso',
      },
    },
    modifier_value: {
      label: 'Valore del modificatore di prezzo',
    },
    round: {
      label: 'Arrotonda il prezzo risultante',
      tooltip:
        'Arrotonda il prezzo risultante per eccesso a 10 (es. 14,91; 14,93; 14,99 diventano 15,00). Utile soprattutto per le regole percentuali',
    },
    is_visible: {
      label: 'Mostra al cliente come offerta',
    },
    name: {
      label: 'Nome',
      placeholder: 'Inserisci un nome comprensibile al cliente',
      default: '{{value}} di sconto su {{resource}}',
    },
  },
  buttons: {
    save: 'Salva',
  },
  toasts: {
    failed_to_load_data: 'Caricamento dati fallito',
    failed_to_save_changes: 'Salvataggio modifiche fallito',
    changes_got_saved: 'Modifiche salvate',
  },
};
